import { createAction } from 'redux-actions';
import { createActionBundle } from 'utilities/request';

export const newReportReset = createAction('NEW_REPORT/RESET');

export const storePdfReport = createAction('CREATE_REPORT/STORE_PDF');

export const uploadCardioVascularReport = createAction('UPLOAD/CARDIO_VASCULAR_REPORT');

export const {
  fetch: uploadDocumentReference,
  request: requestUploadDocumentReference,
  success: requestUploadDocumentReferenceSuccess,
  failure: requestUploadDocumentReferenceFailure,
} = createActionBundle('UPLOAD/DOCUMENT_REFERENCE');

export const {
  fetch: uploadDocumentReferenceBatch,
  request: requestUploadDocumentReferenceBatch,
  success: requestUploadDocumentReferenceBatchSuccess,
  failure: requestUploadDocumentReferenceBatchFailure,
} = createActionBundle('UPLOAD/DOCUMENT_REFERENCE_BATCH');

export const {
  fetch: parsePdf,
  request: requestParsePdf,
  success: requestParsePdfSuccess,
  failure: requestParsePdfFailure,
} = createActionBundle('CARDIO_REPORT/PDF_PARSE');
